import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FaceIcon from '@material-ui/icons/Face';
import TrendIcon from '@material-ui/icons/TrendingUp';
import DoneIcon from '@material-ui/icons/DoneOutline';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { withRouter } from 'react-router-dom';
import mova from 'mova';

const t = mova.ns('admin.menu');

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2)
  },
}));

function ProgrammingAdminMenu(props) {
  const { match, history } = props;

  const classes = useStyles();

  function handleChange(event, newValue) {
    history.push(newValue);
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={match.path}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable force tabs"
        >
          <Tab value='/programming/users' label={t('userManagement')} icon={<FaceIcon />} {...a11yProps(0)} />
          <Tab value='/programming/tests' label={t('availableTests')} icon={<TrendIcon />} {...a11yProps(1)} />
          <Tab disabled value='/programming/tests/:testId' label={t('userTest')} icon={<DoneIcon />} {...a11yProps(2)} />
        </Tabs>
      </AppBar>
    </div>
  );
}

export default withRouter(ProgrammingAdminMenu);
